module.exports = __webpack_public_path__ + "static/img/ai3.d9c03a35.png";